import { yupResolver } from '@hookform/resolvers/yup';
import Button from 'Components/Button';
import ControllerInput from 'Components/ControllerInput';
import ControllerSelect from 'Components/ControllerSelect';
import ControllerTextArea from 'Components/ControllerTextArea';
import Label from 'Components/Label';
import ModalComponent from 'Components/Modal';
import NotificacionesService from 'Services/Http/Notificaciones.service';
import { NotificacionSchema } from 'Services/yup/form';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';

const CreateNotificacion = () => {
  const [stateModal, setStateModal] = useState(false);
  const [messageModal, setMessageModal] = useState('');
  const [typeModal, setTypeModal] = useState('');
  const [loader, setLoader] = useState(false);
  const [roles, setRoles] = useState([]);
  const changeState = (state) => {
    setStateModal(state);
  };
  const {
    handleSubmit,
    control,
    reset,
    formState: { errors }
  } = useForm({
    defaultValues: {
      title: '',
      descripcion: '',
      tipo: ''
    },
    resolver: yupResolver(NotificacionSchema)
  });

  const submit = async (data) => {
    try {
      await NotificacionesService.crearNotificaciones(data);
      setLoader(false);
      setMessageModal('Guardado Exitoso');
      setTypeModal('success');
      setStateModal(true);
      reset();
    } catch (e) {
      console.log(e);
      setLoader(false);
      setStateModal(true);
      setTypeModal('error');
      setMessageModal('Ocurrio un error, revise e intente de nuevo');
    }
  };
  useEffect(() => {
    getRoles();
  }, []);

  const getRoles = async () => {
    const data = [
      {
        label: 'Urgente',
        value: 2
      },
      {
        label: 'Informativo',
        value: 3
      }
    ];
    setRoles(data);
  };

  return (
    <>
      <Label text={'Creacion de notificacion'} />
      <form autoComplete="false">
        <div className="w-full lg:w-1/2 py-5 space-y-4 flex flex-col">
          <div className="w-full xl:w-1/2 space-y-4 flex flex-col">
            <ControllerInput
              control={control}
              name="title"
              error={errors?.title}
              type="text"
              placeholder="Titulo"
            />
          </div>
          <div className="w-full xl:w-1/2 space-y-4 flex flex-col">
            <ControllerTextArea
              control={control}
              name="descripcion"
              placeholder="Descripcion"
              error={errors?.descripcion}
            />
          </div>
          <div className="w-full xl:w-1/2 space-y-4 flex flex-col">
            <ControllerSelect
              data={roles}
              control={control}
              name="tipo"
              error={errors?.tipo}
              label="Seleccionar un tipo de notificacion"
            />
          </div>
        </div>
        <div className="w-full space-y-2 flex flex-col lg:w-1/2 xl:w-1/4 lg:flex-row lg:space-y-0 lg:space-x-3">
          <Button
            onClick={handleSubmit(submit)}
            label="Guardar"
            color="primary"
            type="button"
            loading={loader}
          />
          <Button onClick={reset} label="Limpiar" type="button" />
        </div>
      </form>
      <ModalComponent
        show={stateModal}
        changeState={changeState}
        typeModal="notificacion"
        title={messageModal}
        stateModal={typeModal}
      />
    </>
  );
};

export default CreateNotificacion;
